import React from "react";
import { useNavigate } from "react-router-dom";
import { Badge, Tab, Tabs } from "@mui/material";
import { VISTA_ECHEQUE, rutaEcheq } from "./echeqMenu.constants";

/** El badge queda dentro del tab: si sale del texto, el scroller lo recorta. */
export const sxTabsConBadge = {
  mb: 2,
  pt: 1.5,
  borderBottom: 1,
  borderColor: "divider",
  overflow: "visible",
  "& .MuiTabs-scroller": { overflow: "visible !important" },
  "& .MuiTab-root": {
    overflow: "visible",
    minHeight: 52,
    px: 2,
    mr: 2,
  },
};

export const labelTabConBadge = (texto, count) => {
  const n = Number(count) || 0;
  if (n <= 0) return texto;
  return (
    <Badge
      badgeContent={n > 99 ? "99+" : n}
      color="error"
      sx={{ "& .MuiBadge-badge": { right: 0, top: 8 } }}
    >
      <span style={{ display: "inline-block", paddingRight: 26 }}>{texto}</span>
    </Badge>
  );
};

/** Cheques / Rechazos. Solo si la persona tiene los dos circuitos. */
export default function TabsCircuitoEcheq({
  vista,
  tieneCheques,
  tieneRechazos,
  pendientesRechazo = 0,
}) {
  const navigate = useNavigate();
  if (!tieneCheques || !tieneRechazos) return null;

  return (
    <Tabs
      value={vista}
      onChange={(_e, value) => navigate(rutaEcheq({ vista: value }))}
      sx={sxTabsConBadge}
    >
      <Tab label="Cheques" value={VISTA_ECHEQUE.CHEQUES} />
      <Tab
        label={labelTabConBadge("Rechazos", pendientesRechazo)}
        value={VISTA_ECHEQUE.RECHAZOS}
      />
    </Tabs>
  );
}
